export default __webpack_public_path__ + "static/bg_live22-d73aa66e096bcbc4146933135bbe6b6a.png";